import { render, staticRenderFns } from "./flow-design.vue?vue&type=template&id=596407d6"
import script from "./flow-design.vue?vue&type=script&lang=js"
export * from "./flow-design.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports